// doing this greatly reduces bundle size
// @ts-ignore
import Faker from "faker/lib";
// @ts-ignore
import free_email from "faker/lib/locales/en/internet/free_email";
// @ts-ignore
import example_email from "faker/lib/locales/en/internet/example_email";
// @ts-ignore
import domain_suffix from "faker/lib/locales/en/internet/domain_suffix";
// @ts-ignore
import name from "faker/lib/locales/en/name";
// @ts-ignore
import phone_number from "faker/lib/locales/en_GB/phone_number";

const locale = {
	internet: { free_email, example_email, domain_suffix },
	name,
	phone_number,
};

const faker = new Faker({
	locale: "custom",
	localeFallback: "custom",
	locales: {
		custom: locale,
	},
});

export default faker;
